import { render, staticRenderFns } from "./CommunitySettingsCollaborators.vue?vue&type=template&id=e8492f70&scoped=true&"
import script from "./CommunitySettingsCollaborators.vue?vue&type=script&lang=js&"
export * from "./CommunitySettingsCollaborators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8492f70",
  null
  
)

export default component.exports